import React, { Component } from "react";
import PropTypes from "prop-types";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { Grid, Paper, Button, MenuItem } from "@material-ui/core";

import InputFormat from "../../../../partials/inputForm";
import Loading from "../../../loading";
import Snackbar from "../../../snackbar";
import { styles } from "./styles";

class DeveloperAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        tag: "sms"
      },
    };
  }
  componentDidMount() {
  }
  handleChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    let { data } = this.state;
    data[name] = value;
    this.setState({
      data,
    });
  };
  validateData = () => {
    let { t } = this.props;
    let { data } = this.state;
    let check = true;
    if(!data.username){
      this.mSnackbar.handleClick(t("create_developer_account_pls_fill_username"), "warning");
      check = false
    }
    else if(!data.password){
      this.mSnackbar.handleClick(t("create_developer_account_pls_fill_password"), "warning");
      check = false
    }
    return check
  }
  handleSubmit = async () => {
    const _this = this;
    let { t } = this.props;
    let { data } = this.state;
    let checkData = this.validateData()
    if (checkData) {
      this.loading.startLoading();
      let check = await this.props.create(data);
      if (check.code === 1) {
        this.mSnackbar.handleClick(t("create_developer_account_success"));
        this.props.addNewAccount()
      } else if (check.error === 1201) {
        this.mSnackbar.handleClick(
          t("create_developer_account_account_exist"),
          "error"
        );
      } else if (check.error === 1203) {
        this.mSnackbar.handleClick(
          t("create_developer_account_service_tag_exist"),
          "error"
        );
      } else {
        this.mSnackbar.handleClick(
          t("create_developer_account_unsuccess: " + check.error),
          "error"
        );
      }
      this.loading.stopLoading();
    }
  };
  render() {
    const { t, classes } = this.props;
    const { data } = this.state;
    return (
      <React.Fragment>
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <Loading onRef={(id) => (this.loading = id)} />
        <Grid className={classes.container} container spacing={3}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <InputFormat
              required
              label={t("create_developer_account_username")}
              name="username"
              value={data.username}
              onChange={this.handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <InputFormat
              required
              label={t("create_developer_account_password")}
              name="password"
              type="password"
              value={data.password}
              onChange={this.handleChange}
            />
          </Grid>
          <Grid
            container
            justify="flex-start"
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            style={{ textAlign: "start" }}
          >
            <InputFormat
              select
              label={t("create_developer_account_tag")}
              name="tag"
              required
              value={data.tag}
              onChange={this.handleChange}
              fullWidth={true}
            >
              <MenuItem value="sms">
                {t("create_developer_account_sms")}
              </MenuItem>
            </InputFormat>
          </Grid>
          <Grid
            container
            justify="flex-end"
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <Button
              variant="contained"
              color="secondary"
              onClick={this.props.addNewAccount}
              className={classes.button}
            >
              {t("update_developer_account_cancelbtn")}
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={this.handleSubmit}
              className={classes.button}
            >
              {t("create_developer_account_createbtn")}
            </Button>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

DeveloperAccount.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};
const mapState = (state) => ({
});
const mapDispatch = (dispatch) => ({
  create: dispatch.developerAccount.create,
});
export default translate("translations")(
  withStyles(styles, { withTheme: true })(
    connect(mapState, mapDispatch)(DeveloperAccount)
  )
);
